import { lazy, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { COOKIE_KEY, cookieUtils } from '@app/app/cookie';
import { usePaymentNotify } from '@app/app/model';
import { QueryProvider } from '@app/app/providers/query-client-provider';
import { useBugbugOnboardingSkip } from '@app/features/onboarding';
import { useRtlDirection } from '@app/hooks/use-rtl-direction';
import { useViewportMeta } from '@app/hooks/use-viewport-meta';
import { RegisterQuizFullWidth } from '@app/widgets/register-quiz/ui/register-quiz-full';

const CookiePopup = lazy(() => import('@app/modals/cookie-popup'));
const PaymentCancelNotify = lazy(() => import('@app/modals/paymentCancelNotify'));
const PaymentSuccessNotify = lazy(() => import('@app/modals/paymentSuccessNotify'));
const PaymentErrorNotify = lazy(() => import('@app/modals/paymentErrorNotify'));

export function RootLayout() {
  const location = useLocation();
  useRtlDirection();
  useViewportMeta(location.pathname);

  const paymentNotify = usePaymentNotify();
  const parsePaymentParams = usePaymentNotify((s) => s.parsePaymentParams);

  const [showCookiePopup, setShowCookiePopup] = useState(
    !cookieUtils.get(COOKIE_KEY.cookieAccepted),
  );
  const [showQuiz, setShowQuiz] = useState(!!cookieUtils.get(COOKIE_KEY.showQuiz));

  useEffect(() => {
    parsePaymentParams();
  }, [parsePaymentParams]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!location.pathname.match(/\/create-draft\//)) {
      sessionStorage.removeItem('draftState');
    }
  }, [location.pathname, location.search]);

  useBugbugOnboardingSkip();

  return (
    <QueryProvider>
      <Outlet />
      {showCookiePopup && <CookiePopup close={() => setShowCookiePopup(false)} />}

      {paymentNotify.showSuccess && <PaymentSuccessNotify close={paymentNotify.closeSuccess} />}

      {paymentNotify.showError && <PaymentErrorNotify close={paymentNotify.closeError} />}

      {paymentNotify.showCancel && (
        <PaymentCancelNotify
          close={paymentNotify.closeCancel}
          backUrl={paymentNotify.cancelBackUrl}
        />
      )}
      {showQuiz && <RegisterQuizFullWidth onClose={() => setShowQuiz(false)} />}
    </QueryProvider>
  );
}
